$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
PopOver = require 'app/scripts/views/lib/pop-over'
MemberMiniProfileView = require 'app/scripts/views/member-menu-profile/member-mini-profile-view'
{ Analytics } = require '@trello/atlassian-analytics'

module.exports = class AboutThisBoardAdminListView extends View
  viewTitleKey: 'multi admin list'

  initialize: ->
    @listenTo @model

  render: ->
    data = @model.toJSON()

    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendScreenEvent
        name: 'aboutThisBoardAdminListScreen'
        containers:
          board:
            id: @model.id

    @$el.html(
      templates.fill(
        'popover_about_this_board_admin_list',
        data
      )
    )

    @renderAdminList()

    @

  renderAdminList: ->
    $target = @$('.js-show-all-admins')
    visibleAdmins = @model.orderedVisibleAdmins()

    subviews = for admin in visibleAdmins
      @subview(MemberMiniProfileView, admin, { board: @model })
    @ensureSubviews(subviews, $target)
